// extracted by mini-css-extract-plugin
module.exports = {"offerButton":"offer-selector__offerButton___jybxq","icon":"offer-selector__icon___15F4V","name":"offer-selector__name___1MgXk","rightArrow":"offer-selector__rightArrow___3E4Bh"};